import apiClient from '../lib/axios';

export interface TrainingNavItem {
  id: string;
  label: string;
  file: string;
  category?: string;
}

export interface TrainingNavigation {
  navigation: TrainingNavItem[];
  defaultDocId: string;
}

export interface TrainingContent {
  content: string;
  title: string;
  file: string;
}

class TrainingService {
  async getNavigation(): Promise<TrainingNavigation> {
    const response = await apiClient.get('/training/navigation');
    return response.data.data;
  }

  async getDocContent(docId: string): Promise<TrainingContent> {
    const response = await apiClient.get(`/training/content/${docId}`);
    return response.data.data;
  }
}

export const trainingService = new TrainingService();
